/**
 * @file dispatchScope.ts
 * Exports a method to add a submitted answer to the answers within AppState.
 */
import { actionProps } from './dispatchAnswerSingle';

/**
 * Helper method that will keep scope3 answer upto date in app context
 *
 * @param {Object} action
 *   Dispatch action object.
 *
 * @returns {String}
 *   It return sring value either Yes or NO
 */
export default (action: actionProps): string => {
  return action.scope3;
};
